import { JSEncrypt } from "jsencrypt";
import CryptoJS from "crypto-js";

export function encryptString(plainText, publicKey) {
  const encrypt = new JSEncrypt();
  encrypt.setPublicKey(publicKey);
  const encrypted = encrypt.encrypt(plainText);
  return encrypted;
}

// Decryption function to process API response
export function convertData(data) {
  try {
    const encrypted = JSON.parse(atob(data));
    const key = CryptoJS.AES.decrypt(
      "U2FsdGVkX18gSi5YMu26JvFGQHWJ6FPGYrq0bk/29eUPWB/FRi8gsd87dwvURJdgSahfRvTL1H9YYWjKrody7w==",
      "secrete@123"
    ).toString(CryptoJS.enc.Utf8);
    const decrypted = JSON.parse(
      CryptoJS.AES.decrypt(encrypted.value, CryptoJS.enc.Base64.parse(key), {
        iv: CryptoJS.enc.Base64.parse(encrypted.iv),
      }).toString(CryptoJS.enc.Utf8)
    );
    return decrypted;
  } catch (error) {
    throw new Error("Decryption failed: " + error.message);
  }
}

// Set API base URL based on environment
export function getApiBaseUrl(environment, error) {
  const validEnvironments = ["staging", "prod"];
  if (!environment || !validEnvironments.includes(environment)) {
    throw Object.assign(new Error(error), {
      code: "INVALID_ENVIRONMENT",
    });
  }
  return environment === "staging"
    ? "https://staging.paymid.com/api/v1"
    : "https://app.paymid.com/api/v1";
}
